/* unplugin-vue-components disabled */import script from "./MaxMonthRate.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxMonthRate.vue?vue&type=script&setup=true&lang=js"

import "./MaxMonthRate.vue?vue&type=style&index=0&id=e045b2d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e045b2d4"]])

export default __exports__